import { createClient } from '@supabase/supabase-js'

// Project ID will be auto-injected during deployment
const SUPABASE_URL = 'https://nihiuixoqdaljpvdstwd.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5paGl1aXhvcWRhbGpwdmRzdHdkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3OTI1MTc5OTEsImV4cCI6MjEwODA5Mzk5MX0.6wIe7NrSlp4euqe8gFeAToYNzqWSjgoDllFKBeaiU3s'

if(!SUPABASE_URL || !SUPABASE_ANON_KEY ){
  throw new Error('Missing Supabase variables');
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})